import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, firstValueFrom } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

// Services
import { ApiService } from './api.service';
import { LocalStorageService } from './local-storage.service';
import { GeneralService } from './general.service';
import { RoutingService } from './routing.service';
import { DataService } from './data.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable()

export class PlayerProfileService {
    public playerProfileDataEmitter: EventEmitter<any> = new EventEmitter();
    public loadPlayerProfileDataEmitter: EventEmitter<any> = new EventEmitter();
    public loadRegulationStatusDataEmitter: EventEmitter<any> = new EventEmitter();
    public profileData: any = {};
    public playerQueryParamToken: any = '';
    public regulationStatusData: any = '';
    public playerLimitData: any;
    public genericConfigData = null;
    private genericConfigSubject = new ReplaySubject<any>(1);
    public genericConfig$ = this.genericConfigSubject.asObservable();
    
    constructor(
        public dialog: MatDialog,
        private _apiService: ApiService,
        private _localStorageService: LocalStorageService,
        private _generalService: GeneralService,
        private _routingService: RoutingService,
        private _dataService: DataService
    ) { }

    // GET Player Detail API
    getPlayerProfile(isLoader: boolean): Observable<any> {
        return this.genericConfig$.pipe(
            take(1), // Wait until the first config value arrives
            switchMap(config => {
                let apiUrl = 'profile/v3/profile-v3'; 
                
                // Now 'config' is guaranteed to be the data from your API
                if (config?.genericProfileEnable) {
                    apiUrl = 'player/profile/playerdetails';
                }
                
                return this._apiService.request('get', apiUrl, '', '', isLoader);
            })
        );
    }

    // SAVE Player Profile API
    savePlayerProfil(data: any, params: any = {}): Observable<any> | any {
        let apiUrl = 'profile/v3/profile-v3';
        return this._apiService.request('post', apiUrl, data, params, true);
    }

    // SAVE Schufa Verification
    schufaVerificationApi(param: any = {}): Observable<any> | any {
        let apiUrl = 'schufa/schufaVerification';
        return this._apiService.request('get', apiUrl, {}, param, true);
    }

    // SAVE Schufa Verification
    getPostIdentDocApi(): Observable<any> | any {
        let apiUrl = 'regulations/getPostIdentDoc';
        return this._apiService.request('get', apiUrl, {}, {}, true);
    }

    // SAVE Schufa Verification
    getRegulationsStatus(): Observable<any> | any {
        let apiUrl = 'regulations/getStatus';
        return this._apiService.request('get', apiUrl, {}, {}, true);
    }

    saveContactDetail(data: any): Observable<any> | any {
        let apiUrl = 'contactUs';
        return this._apiService.request('post', apiUrl, data, {}, true, false);
    }

    // This function is return player excluded
    saveExclusions(data: any): Observable<any> | any {
        const apiUrl = 'playerProfile/exclusions';
        return this._apiService.request('post', apiUrl, data, {}, true);
    }

    // This function is return player excluded
    saveSelfBan(data: any): Observable<any> | any {
        const apiUrl = 'playerProfile/ban';
        return this._apiService.request('post', apiUrl, data, {}, true);
    }

    // LOAD Regulatory Consent Data API
    loadRegulatoryConsent(data: any, isLoader: boolean = false): Observable<any> | any {
        let apiUrl = 'playerTnc/v2/view';
        return this._apiService.request('post', apiUrl, data, {}, isLoader, false);
    }

    // GDPR - Load Consent Data API
    updateConsentData(data: any): Observable<any> | any {
        let apiUrl = 'v2/profile/updateConsentData';
        return this._apiService.request('post', apiUrl, data, {}, true);
    }

    // GET Player limit API
    getAllLimits(params: any): Observable<any> | any {
       const apiUrl = 'limits/v1/fetch';
       return this._apiService.request('get', apiUrl, '', params, true);
    }

      // GET Player limit API
    getOldLimits(params: any): Observable<any> | any {
       const apiUrl = 'limits/fetch';
       return this._apiService.request('get', apiUrl, '', params, true);
    }

    // GET Player limit-History API
    getLimitsHistory(data: any): Observable<any> | any {
        const apiUrl = 'playerProfile/get/limits';
        return this._apiService.request('get', apiUrl, {}, data, true);
    }

    // GET Player limit API
    saveLimits(data: any): Observable<any> | any {
        const apiUrl = 'v1/register/limits/set';
        return this._apiService.request('post', apiUrl, data, {}, true);
    }

    // GET setLugasLimit
    setLugasLimit(limitVal: any, qParam: any = {}): Observable<any> | any {
        const apiUrl = 'lugas/setLimit/' + limitVal;
        return this._apiService.request('put', apiUrl, {}, qParam, true);
    }

    // GET lugasCheckLimitApi API
    lugasCheckLimitApi(): Observable<any> | any {
        const apiUrl = 'lugas/checkLimit';
        return this._apiService.request('get', apiUrl, {}, {}, true);
    }

    // Load Regulatory Consent Data API
    loadMentorAuthenticate(data: any, isLoader: boolean = false): Observable<any> | any {
        const apiUrl = 'mentor/authenticate';
        return this._apiService.request('get', apiUrl, '', '', false);
    }

    // GET Get Withdraw Threshold API
    getWithdrawThresholdApi(): Observable<any> | any {
        const apiUrl = 'limits/getWithdrawThreshold';
        return this._apiService.request('get', apiUrl, '', '', true);
    }

    // POST Set Withdraw Threshold API
    setWithdrawThresholdApi(data: any): Observable<any> | any {
        const apiUrl = 'limits/setWithdrawThreshold';
        return this._apiService.request('post', apiUrl, data, {}, true);
    }

    // POST DeActivate Withdraw Threshold API
    deActivateWithdrawThresholdApi(data: any): Observable<any> | any {
        const apiUrl = 'limits/deActivateWithdrawThreshold';
        return this._apiService.request('post', apiUrl, data, {}, true);
    }

    // GET Player Profile Detail API
    deletePlayerAccountApi(): Observable<any> | any {
        let apiUrl = 'v2/profile/deletePlayerAccount';
        return this._apiService.request('get', apiUrl, '', {}, true);
    }

    // checkPlayerLimitApi
    checkPlayerLimitApi(): Observable<any> | any {
        let apiUrl = 'lugas/checkPlayer';
        return this._apiService.request('get', apiUrl, '', {}, true);
    }

    // Player State API
    lugasPlayerstate(state: boolean): Observable<any> | any {
        let apiUrl = `lugas/playerstate/${state}`;
        return this._apiService.request('put', apiUrl, '', {}, true);
    }

    // GET PROFILE DATA API
    playerProfileApi(data): Observable<any> {
        let apiUrl = 'player/profile';
        return this._apiService.request('get', apiUrl, {}, data, true);
    }

    // SAVE PROFILE DATA API
    updateFieldsApi(data: any, params: any = {}): Observable<any> {
        let apiUrl = 'player/profile/updatefields';
        return this._apiService.request('post', apiUrl, data, {}, true);
    }

    profileDataEmitter(data: any) {
        this.playerProfileDataEmitter.emit(data);
    }

    loadProfileData(data: any) {
        this.loadPlayerProfileDataEmitter.emit(data);
    }
    
    loadRegulationStatusData(data: any) {
        this.loadRegulationStatusDataEmitter.emit(data);
    }

    setRegulationStatusData(data: any) {
        this.regulationStatusData = data;
    }

    getRegulationStatusData() {
        return this.regulationStatusData;
    }

    setPlayerProfileData(val: any) {
        this.profileData = val;
    }

    getPlayerProfileData() {
        return this.profileData;
    }

    setPlayerQueryParamsToken(val: any) {
        this.playerQueryParamToken = val;
    }

    getPlayerQueryParamsToken() {
        return this.playerQueryParamToken;
    }

    setPlayerLimitData(data: any) {
        this.playerLimitData = data;
    }

    getPlayerLimitData() {
        return this.playerLimitData;
    }

    checkPlayerLimitSetting(): Observable<any> | Promise<any> | any {
        let resultPromise = new Promise((resolve, reject) => {
            let userDetail: any = this._localStorageService.get('player');
            if (!userDetail) {
                resolve(true);
                return;
            }
            let limitData = this.getPlayerLimitData();
            if(limitData) {
                if (limitData.isRegistered) {
                    resolve(true);
                } else {
                    resolve(false);
                }
                return resultPromise;
            }
            this.checkPlayerLimitApi().subscribe((res: any) => {
                let data = res || {};
                try {
                    if (data.message) {
                        let msgData = JSON.parse(data.message);
                        this.setPlayerLimitData(msgData);
                        if (msgData.isRegistered) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    } else {
                        resolve(true);
                    }
                } catch (e) {
                    reject(false);
                }
            }, (err: any) => {
                reject(false);
            });
        });
        return resultPromise;
    }

    openPreVerificationModal(verifSatusFlag: any, verificationAssets: any) {
        let title = verificationAssets.text.userIdVerificationPage_reidentify_profile_modal_title;
        let msg = 'Please a new identify';
        if (verifSatusFlag == 'kycExpired') {
            msg = verificationAssets.text.userIdVerificationPage_personal_detail_change_modal_desc;
        } else if (verifSatusFlag == 'ibanStatus') {
            msg = verificationAssets.text.userIdVerificationPage_bank_detail_change_modal_desc;
        } else if (verifSatusFlag == 'fullyVerifiedStatus') {
            title = verificationAssets.text.userIdVerificationPage_verification_modal_title;
            msg = verificationAssets.text.userIdVerificationPage_profile_not_fully_verified_modal_desc;
        } else if (verifSatusFlag == 'preReverificationStatus') {
            msg = verificationAssets.text.userIdVerificationPage_review_and_update_data_modal_desc;
        } else if (verifSatusFlag == 'ibanToVerify') {
            title = verificationAssets.text.userIdVerificationPage_bank_verification_modal_title;
            msg = verificationAssets.text.userIdVerificationPage_iban_verify_modal_desc;
        } else if (verifSatusFlag == 'ibanToReVerify') {
            title = verificationAssets.text.userIdVerificationPage_bank_Reverification_modal_title;
            msg = verificationAssets.text.userIdVerificationPage_iban_verify_recheck_modal_desc;
        } else if (verifSatusFlag == 'identityToReVerify') {
            msg = verificationAssets.text.userIdVerificationPage_profile_recheck_modal_desc;
        } else if (verifSatusFlag == 'identityToUploadDocument') {
            msg = verificationAssets.text.userIdVerificationPage_profile_reupload_doc_modal_desc;
        }
        
        let okBtn = verificationAssets.text.userIdVerificationPage_ok_btn_label;
        return this._generalService.infomodel(title, msg, okBtn);
    }

    loadPlayerProfileDetails(isLoader: boolean = false) {
        this.getPlayerProfile(isLoader).subscribe((res: any) => {
            try {
                let data = res || {};
                let playerProfileDetail = JSON.parse(data.message);
                this.setPlayerProfileData(playerProfileDetail);
            } catch (e) {
                console.log('exception caught in loadPlayerProfileDetails', e);
            }
        }, (error: any) => {
            console.log(error);
        });
    }

    loadRegulationsStatusIdVerification() {
        let playerFlag: any = this._localStorageService.get('playerFlag');
       this.getRegulationsStatus().subscribe((res: any) => {
            let message = res.message || {};
            let userProfileIdVerificationAssets = this._dataService.getAssets('userProfileIdVerificationPage');

            this.setRegulationStatusData(message);
            this.oasisStatusFlageUpdate(message);
            if (playerFlag && (playerFlag.playerKycLevel <= 1)) {
                return true; // after code not execute DV-6150
            }
            let playerVerificationStatus = message.playerVerificationStatus || {};
            if (message.preReverificationStatus || message.reverificationStatus) {
                let preVerifStatusDialogRef = this.openPreVerificationModal('preReverificationStatus', userProfileIdVerificationAssets);
                preVerifStatusDialogRef.afterClosed().subscribe(result => {
                    let isGenericConfigData: any = this.getGenericConfigData();
                    if (isGenericConfigData?.genericProfileEnable) {
                        this._routingService.altRouterLink('user/account/account-details-pnp');
                    } else {
                        this._routingService.altRouterLink('user/account/account-details');
                    }
                });
            } else if (playerVerificationStatus.identityToVerify && (playerFlag && (playerFlag.playerKycLevel > 1))) {
                let confirmModal = this._generalService.infomodel('', '', userProfileIdVerificationAssets.text.userIdVerificationPage_ok_btn_label, null, 'checkConfirmKycLevel');
                confirmModal.afterClosed().subscribe(result => {
                    if (result) {
                        this._routingService.altRouterLink('user/verification');
                    }
                });
            } /* else if (playerVerificationStatus.ibanToVerify) {
                let ibanToVerifyDialogRef = this.openPreVerificationModal('ibanToVerify', userProfileIdVerificationAssets);
                ibanToVerifyDialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this._localStorageService.set('isOtherVerifyOptions', true);
                        this._routingService.altRouterLink('user/verification');
                    }
                });
            } */ else if (playerVerificationStatus.identityToReVerify) {
                let identityToReVerifyDialogRef = this.openPreVerificationModal('identityToReVerify', userProfileIdVerificationAssets);
                identityToReVerifyDialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this._routingService.altRouterLink('user/verification');
                    }
                });
            } 
            
            /*else if (playerVerificationStatus.ibanToReVerify) {
                let ibanToReVerifyDialogRef = this.openPreVerificationModal('ibanToReVerify', userProfileIdVerificationAssets);
                ibanToReVerifyDialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this._localStorageService.set('isOtherVerifyOptions', true);
                        this._routingService.altRouterLink('user/verification');
                    }
                });
            } */
            else if (!message.fullyVerifiedStatus) {
                let fullyVerifStatusDialogRef = this.openPreVerificationModal('fullyVerifiedStatus', userProfileIdVerificationAssets);
                fullyVerifStatusDialogRef.afterClosed().subscribe(result => {
                    if (message.schufaStatus || message.pxlStatus) {
                        this._routingService.altRouterLink('user/account/bank-details');
                    } else {
                        this._routingService.altRouterLink('user/verification');
                    }
                });
            } else if (message.manualQualificationExpiringSoon) {
                let expiringSoonDialogRef = this.openPreVerificationModal('identityToUploadDocument', userProfileIdVerificationAssets);
                expiringSoonDialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this._localStorageService.set('isLugasLimitDocumentUpload', true);
                        this._routingService.altRouterLink('user/documents');
                    }
                });
            }
        }, (err: any) => {
            if (err.errors) {
                if (err.errors.length) {
                    let errArr = err.errors;
                    errArr.map((val: any) => {
                        this._generalService.toastError(val.errorMessage);
                    });
                } else {
                    this._generalService.toastError(err.message);
                }
            }
        });
    }

    getRegulationsStatusApi(): Observable<any> | Promise<any> | any {
        let resultPromise = new Promise((resolve, reject) => {
            this.getRegulationsStatus().subscribe((res: any) => {
                if (res.success) {
                    let data = res.message;
                    resolve(data);
                }
            }, (error: any) => {
                reject(false);
            });
        });
        return resultPromise;
    }

    checkConfigurationDetailApi(): Observable<any> | any {
        let apiUrl = 'profile/v3/checkConfigurationDetails?identifier=PROVISIONAL_PLAY_ENABLE';
        return this._apiService.request('get', apiUrl, {}, {}, false, true);
    }

    async checkConfigurationDetailConfig(): Promise<boolean> {
        try {
            const res: any = await firstValueFrom(this.checkConfigurationDetailApi());
            return res?.message?.isConfigurationEnabled ?? false;
        } catch (error) {
            console.log('checkConfigurationDetailConfig error:', error);
            return false;
        }
    }

    // POST Save Verify Confirm API
    saveVerifyConfirmApi(): Observable<any> | any {
        const apiUrl = 'saveVerifyConfirm';
        return this._apiService.request('post', apiUrl, {}, {}, true);
    }
    // ok button to call API
    saveVerifyConfirmApiSubscribe(homePageAsset, page: string = '') {
        this.saveVerifyConfirmApi().subscribe((res: any) => {
            let data = res || {};
            if (data.success) {
                let message = data.message;
                if(message.result) {
                    let player: any = this._localStorageService.get('player');
                    player['playerKycPopupEnableFlag'] = false;
                    this._localStorageService.set('player', player);
                }
            } else {
                if (data.errorCode == 8346) {
                    this._generalService.toastError(homePageAsset?.errormsg?.homePage_provisional_play_notice_error_8346);
                } else if (data.errorCode == 8347) {
                    this._generalService.toastError(homePageAsset?.errormsg?.homePage_provisional_play_notice_error_8347);
                } else if (data.errorCode == 8348) {
                    this._generalService.toastError(homePageAsset?.errormsg?.homePage_provisional_play_notice_error_8348);
                } else if (data.errorCode == 8356) {
                    this._generalService.toastError(homePageAsset?.errormsg?.homePage_provisional_play_notice_error_8356);
                } 
            }

            if(page && page == 'game') {
                this._routingService.altRouterLink('home');
            }
        }, (err: any) => {
            this.dialog.closeAll();
            console.log('saveVerifyConfirm error', err);
            if(page && page == 'game') {
                this._routingService.altRouterLink('home');
            }
        });
    }
    // Check for newly register player confirm modal
    async checkFirstDepositGameNoticeStatus(homePageAsset: any) {
        const genericConfigData: any = this.getGenericConfigData();
        const playerDetails: any = this.getPlayerProfileData();
        let isConfigEnabled = await this.checkConfigurationDetailConfig();
        if (genericConfigData?.genericProfileEnable) {
            isConfigEnabled = playerDetails?.provisionalPlay;
        }       
        // console.log('isConfigEnabled>>>>', isConfigEnabled);
        if (isConfigEnabled) {
            return;
        }
    
        this.getRegulationsStatusApi().then((res: any) => {
            if (res) {
                this.setRegulationStatusData(res);
                this.oasisStatusFlageUpdate(res);
                let playerDetail: any = this._localStorageService.get('player');
                if (playerDetail.playerKycPopupEnableFlag && res.playerKycPopupEnable) {
                    this.dialog.closeAll();
                    let infoModel =  this._generalService.infomodel(
                        homePageAsset?.text?.homePage_provisional_play_notice_modal_title,
                        homePageAsset?.text?.homePage_provisional_play_notice_modal_desc,
                        homePageAsset?.text?.homePage_provisional_play_notice_modal_ok_btn_label,
                        '',
                        'checkFirstDepositGameNoticeModal'
                    );
                    infoModel.afterClosed().subscribe(result => {
                        if (result) {
                            this.saveVerifyConfirmApiSubscribe(homePageAsset);
                        }
                    });
                }
            }
        }, (error: any) => {
            console.log('checkFirstDepositGameNoticeStatus error====', error);
        })
    }
    // getStatus API oasis status flag updates
    oasisStatusFlageUpdate(data: any) {
        let oasisStatus = data.oasisStatusData || {};
        let playerObj = this._localStorageService.get('player');
        playerObj['banStatus'] = oasisStatus.banStatus;
        playerObj['isbonusAllow'] = oasisStatus.isbonusAllow;
        playerObj['isadvertisementAllow'] = oasisStatus.isadvertisementAllow;
        this._localStorageService.set('player', playerObj);
    }

    // GET Player Account Generic Configuration API
    getGenericConfigApi(): Observable<any> {
        let apiUrl = 'getGenericConfiguration';
        return this._apiService.request('get', apiUrl, '', '', false, false);
    }

    playerAccountGenericConfig() : Observable<any> | Promise<any> | any {
        let defaultConfig = {
            genericRegistrationEnable: true,
            genericProfileEnable: true,
            genericLoginEnable: false,
            genericForgotPasswordEnable: false
        };

        let resultPromise = new Promise((resolve, reject) => {
            this.getGenericConfigApi().subscribe((res: any) => {
                if (res.success) {
                    let data = JSON.parse(res.message);
                    this.setGenericConfigData(data);
                    resolve(data);
                } else {
                    this.setGenericConfigData(defaultConfig);
                    resolve(defaultConfig);
                }
            }, (err: any) => {
                this.setGenericConfigData(defaultConfig);
                resolve(defaultConfig);
            });
        });
        return resultPromise;
    }

    playerAccountGenericConfigData(): Promise<any> {
        let genericConfigDataObj: any = this.getGenericConfigData() || {};
        if (Object.keys(genericConfigDataObj).length) {
            return genericConfigDataObj;
        }

        return this.playerAccountGenericConfig().then((res: any) => {
            let defaultConfig = res || {};
            this.setGenericConfigData(defaultConfig);
            return defaultConfig;
        });
    }

    setGenericConfigData(data) {
        this.genericConfigData = data;
        this.genericConfigSubject.next(data);
    }

    getGenericConfigData() {
        return this.genericConfigData;
    }

    // POST GGL Max-Bet (§22a €5) Data Processing Consent API
    postGglMaxBetConsent(status: string): Observable<any> | any {
        return this._apiService.request('post', 'player/profile/consent/ggl-maxbet', { status }, {}, true);
    }
}
